import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { MatchStream } from "@/types/SportsApiResponses";

export interface GetStreamsParams {
  providerId: number;
  providerMatchId: number;
}

export const getStreams = async (
  props: QueryProps<GetStreamsParams>
): Promise<MatchStream[]> => {
  const { providerId, providerMatchId } = props.params;
  const res = await api.client.get(`/matches/streams`, {
    signal: props.signal,
    params: { providerId, providerMatchId },
  });
  return res.data;
};
